/* tslint:disable */
/* eslint-disable */
/**
 * Neptune Leaderboard REST API
 * Public REST API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: contact@neptune.ml
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { EvaluationSource } from './EvaluationSource';
import {
    EvaluationSourceFromJSON,
    EvaluationSourceFromJSONTyped,
    EvaluationSourceToJSON,
} from './EvaluationSource';

/**
 * 
 * @export
 * @interface EvaluationRecordsRequest
 */
export interface EvaluationRecordsRequest {
    /**
     * Opaque continuation token returned by the preceding page
     * @type {string}
     * @memberof EvaluationRecordsRequest
     */
    nextToken?: string;
    /**
     * Maximum number of typed metric values, default 1000
     * @type {number}
     * @memberof EvaluationRecordsRequest
     */
    pageSize?: number;
    /**
     * 
     * @type {EvaluationSource}
     * @memberof EvaluationRecordsRequest
     */
    source?: EvaluationSource;
    /**
     * Ordered selection of 1 through 1000 sources in one project; mutually exclusive with source
     * @type {Array<EvaluationSource>}
     * @memberof EvaluationRecordsRequest
     */
    sources?: Array<EvaluationSource>;
}

/**
 * Check if a given object implements the EvaluationRecordsRequest interface.
 */
export function instanceOfEvaluationRecordsRequest(value: object): value is EvaluationRecordsRequest {
    return true;
}

export function EvaluationRecordsRequestFromJSON(json: any): EvaluationRecordsRequest {
    return EvaluationRecordsRequestFromJSONTyped(json, false);
}

export function EvaluationRecordsRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): EvaluationRecordsRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'nextToken': json['nextToken'] == null ? undefined : json['nextToken'],
        'pageSize': json['pageSize'] == null ? undefined : json['pageSize'],
        'source': json['source'] == null ? undefined : EvaluationSourceFromJSON(json['source']),
        'sources': json['sources'] == null ? undefined : ((json['sources'] as Array<any>).map(EvaluationSourceFromJSON)),
    };
}

export function EvaluationRecordsRequestToJSON(value?: EvaluationRecordsRequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'nextToken': value['nextToken'],
        'pageSize': value['pageSize'],
        'source': EvaluationSourceToJSON(value['source']),
        'sources': value['sources'] == null ? undefined : ((value['sources'] as Array<any>).map(EvaluationSourceToJSON)),
    };
}

